import {Injectable} from '@angular/core'
import {adminRole} from '../access-roles/admin.role'
import {customerRole} from '../access-roles/customer.role'
import {employeeRole} from '../access-roles/employee.role'
import {getRoleModel, RoleModel} from "../../shared/models/role/role.model";
import {sidenavConfig} from "../../shared/constants/sidenav.config";
import {externalRole} from "../access-roles/external.role";
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root'
})
export class AccessControlService {

  getRole = (role: string) => {
    switch (role) {
      case "bergh-employee":
        return employeeRole.name
      case "bergh-admin":
        return adminRole.name
      case "bergh-external":
        return externalRole.name
      case "bergh-customer":
        return customerRole.name
      default:
        return `??${role}??`
    }
  }

  private readonly roleModel: RoleModel;

  constructor(private keycloak: Keycloak) {
    this.roleModel = getRoleModel(this.keycloak.tokenParsed.roles.map(role => this.getRole(role)))
  }

  public async logout(): Promise<void> {
    localStorage.clear()
    await this.keycloak.logout()
  }

  public getEmail(): string {
    return this.keycloak.tokenParsed.email
  }

  public getName(): string {
    return this.keycloak.tokenParsed.name
  }

  public isAdmin(): boolean {
    return this.roleModel === adminRole
  }

  public isEmployee(): boolean {
    return this.roleModel === employeeRole
  }

  public isCustomer(): boolean {
    return this.roleModel === customerRole
  }

  public isExternal(): boolean {
    return this.roleModel === externalRole
  }

  public getAccessValue(module: string, action: string): boolean {
    return this.roleModel[module][action]
  }

  public getNavMenu(): any[] {
    const activeNav = []
    sidenavConfig.forEach(element => {
      if (this.getAccessValue(element.module, 'view')) {
        activeNav.push(element)
      }
    })
    return activeNav
  }
}
